<template>
    <div  class="tw-relative tw-z-10 tw-max-w-xl">
        <h1 class="tw-font-medium tw-text-32 md:tw-text-40 lg:tw-text-56 tw-mb-3 md:tw-mb-6 lg:tw-mb-8" v-t="'website.configurator.title'"></h1>
        <div class="tw-text-16 md:tw-text-20" v-t="'website.configurator.intro'"></div>
    </div>
</template>